import axiosInstance from "../axiosInstance";

export const GETConsultarStock = async (parametroBusqueda) => {
  try {
    const encoded = encodeURIComponent(String(parametroBusqueda));

    const url = new URL(
      `/solicitudes/${encoded}/consultar-stock`,
      process.env.REACT_APP_WMS_BASE_URL,
    );

    const response = await axiosInstance.get(url.toString(), {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default GETConsultarStock;
